import { defineMessage } from 'services/localization';

export const messages = {
    popupTitle: defineMessage('bill_to_purchase_order_matching'),
    saveButtonText: defineMessage('save'),
    excessAmountWarning: defineMessage('allocated_amounts_cant_exceed_the_bill_amount'),
};
